import { Trans } from "react-i18next"

import FormattedComment from "components/lib/FormattedComment"
import util from "utils/utils"

export default function DiscussionPostedContent({ ownerGroup, events }) {
  return (
    <Trans
      i18nKey="notifications.groupDiscussion"
      values={{
        name: util.getEventNames(events),
        group: ownerGroup?.name || "Deleted",
        comment: events[0]?.comment || "",
      }}
      components={{
        b: <b />,
        formattedComment: <FormattedComment noLink />,
      }}
    />
  )
}
